import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, ProductSubscriptionSuccessFeeTier } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCompanySubscriptionSuccessFeeTiersQuery(
	companyGuid?: Guid | undefined,
	subscriptionGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<ProductSubscriptionSuccessFeeTier[], unknown, ProductSubscriptionSuccessFeeTier[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Company.SubscriptionTiers(companyGuid, subscriptionGuid),
		() =>
			AxiosUtils.getResponseData<ProductSubscriptionSuccessFeeTier[]>(
				api.get(CerebroApiEndpoints.Company.SuccessFeeTiers(companyGuid, subscriptionGuid))
			),
		options
	);
}
